import { render } from "./SolarSystem.vue?vue&type=template&id=5e9e613c&scoped=true"
import script from "./SolarSystem.vue?vue&type=script&lang=js"
export * from "./SolarSystem.vue?vue&type=script&lang=js"

import "./SolarSystem.vue?vue&type=style&index=0&id=5e9e613c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9e613c"]])

export default __exports__